import qs from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useTabs = (defaultTab: string) => {
  const [tab, setTab] = useState(defaultTab);

  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const chooseTab = (tab: string) => setTab(tab);

  const getRedirect = () => {
    const params: { redirect_tab?: string } = qs.parse(search);
    if (!params.redirect_tab) return;

    if (params.redirect_tab !== tab) {
      setTab(params.redirect_tab);
    }
    navigate(pathname, { replace: true });
  };

  useEffect(getRedirect, [pathname, search, tab, navigate]);

  return {
    tab,
    chooseTab,
  };
};
